import { type MantineColorScheme } from '@mantine/core'
import Image from 'next/image'

type ShalionLogoProps = {
  colorScheme?: MantineColorScheme
}

const ShalionLogo = (props: ShalionLogoProps) => {
  const { colorScheme = 'light' as MantineColorScheme } = props

  const logoUrl = `/assets/svg/shalion-logo-${colorScheme === 'light' ? 'light' : 'dark'}.svg`

  return <Image alt='Shalion Logo' height={24} src={logoUrl} width={112} />
}

export default ShalionLogo
